import { UseQueryOptions } from "@tanstack/react-query"

import { useQueryHook } from "@/hooks"
import { ApiError } from "@/app/api/type"
import {
  ReadAiReportListResponse,
  ReadAiReportDetailParams,
  ReadAiReportDetailResponse,
} from "@/types/aiReport"
import { readAiReportList, readAiReportDetail } from "@/app/api/aiReport"

export const useAiReportListQuery = () => {
  return useQueryHook<ReadAiReportListResponse, unknown>({
    queryKey: ["readAiReportList"],
    queryFn: () => readAiReportList(),
  })
}

export const useAiReportDetailQuery = (idfReport: number | null) => {
  return useQueryHook<ReadAiReportDetailResponse, ReadAiReportDetailParams>({
    queryKey: ["readAiReportDetail", idfReport],
    queryFn: () => readAiReportDetail({ idfReport: idfReport! }),
    options: {
      enabled: !!idfReport,
    } as UseQueryOptions<ReadAiReportDetailResponse, ApiError>,
  })
}
